import { Component } from '@angular/core';

@Component({
  selector: 'app-info-erro',
  templateUrl: './info-erro.component.html',
  styleUrls: ['./info-erro.component.scss']
})
export class InfoErroComponent {

  public year = new Date().getFullYear();

  tituloMensagem = 'Seu pedido foi gerado!';
  descricaoMensagem = 'Houve uma instabilidade ao gerar o recibo. Mas não se preocupe, seu pedido foi finalizado. Por favor, entre em contato com nosso suporte pelos canais abaixo para que possamos enviar o recibo para você.';
  contato = { telefone: '(15) 3205-8892' };

}
